import React, { Component } from 'react';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import { AppProperties } from '../common/function';
import {
  Grid,
  Divider,
  Cell,
  DataTable,
  TableBody,
  TableRow,
  TableColumn,
  TableHeader,
  TablePagination,
  Button,
  SelectionControl
} from 'react-md';
import '../css/QuizListWidget.css';
import Moment from 'moment'
import ReactTooltip from 'react-tooltip';
import { NotificationManager } from 'react-notifications';

const quizDataDummy = [
  {
    quiz_id: 523,
    quiz_name: 'create new assignment 101',
    start_date: '27/02/2018',
    start_time: '00:00:00',
    end_date: '27/02/2018',
    end_time: '00:00:00',
    quiz_type: 1,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 528,
    quiz_name: 'check order 3',
    start_date: '08/03/2018',
    start_time: '00:00:00',
    end_date: '12/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 78,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 529,
    quiz_name: 'order 4',
    start_date: '08/03/2018',
    start_time: '19:56:00',
    end_date: '22/03/2018',
    end_time: '19:57:00',
    quiz_type: 1,
    mastery_condition: 6,
    mastery_units: 8,
    maximum_attempted: 9,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 532,
    quiz_name: 'test 1',
    start_date: '08/03/2018',
    start_time: '20:10:00',
    end_date: '11/03/2018',
    end_time: '20:10:00',
    quiz_type: 1,
    mastery_condition: 4,
    mastery_units: 5,
    maximum_attempted: 6,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 533,
    quiz_name: 'test 2',
    start_date: '08/03/2018',
    start_time: '20:16:00',
    end_date: '15/03/2018',
    end_time: '20:16:00',
    quiz_type: 1,
    mastery_condition: 6,
    mastery_units: 7,
    maximum_attempted: 8,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 534,
    quiz_name: 'test 3',
    start_date: '08/03/2018',
    start_time: '00:00:00',
    end_date: '22/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 535,
    quiz_name: 'test timer',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '19/03/2018',
    end_time: '00:00:00',
    quiz_type: 2,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '30',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 536,
    quiz_name: 'timer test 1',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '19/03/2018',
    end_time: '00:00:00',
    quiz_type: 2,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '30',
    randomize_categories: 2,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 539,
    quiz_name: 'random',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '12/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 6,
    mastery_units: 7,
    maximum_attempted: 8,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  }
];
export default class QuizListWidget extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      course_name: '',
      section_name: '',
      quiz_data: [],
      slicedData: [],
      loadingNumberOfCompletedStudent : true,
      NumberOfCompletedStudent : {},
      currentPageCount: 0,
    };
  }

  getNumberOfStudentsCompletedData(req_course_id, req_section_id) {
    const payload = {
      course_id: parseInt(req_course_id, 10),
      section_id: parseInt(req_section_id, 10)
    };

    return new Promise(function(resolve, reject) {
      ApiRequestService({
        method: 'post',
        //url: 'http://localhost:8095/getAllQuiz',
        url: '/getQuizStudentsCompleted',
        data: payload
      }).then(res => {
          if (res.data !== undefined && res.data !== null && 
            res.data.data !== undefined && res.data.data !== null 
          ) {
            return resolve(res.data.data);
          } else {
            console.error('Empty Data');
            return resolve({});
          }
        }).catch(error => {
          console.error('Error When Retriving Quiz Details ', error);
          return resolve({});
        });
    });
  }
  getQuizData(req_course_id, req_section_id) {
    const payload = {
      course_id: parseInt(req_course_id, 10),
      section_id: parseInt(req_section_id, 10)
    };

    return new Promise(function(resolve, reject) {
      ApiRequestService({
        method: 'post',
        //url: 'http://localhost:8095/getAllQuiz',
        url: '/getAllQuiz',
        data: payload
      })
        .then(res => {
          if (res != null && res.data != null &&  res.data.data != null &&
            res.data.data.quizes_list !== null &&
            res.data.data.quizes_list !== undefined &&
            res.data.data.quizes_list.length > 0
          ) {
            return resolve(res.data.data.quizes_list);
          } else {
            console.error('Quiz Data Empty');
            let emptyArray = [];
            return resolve(emptyArray);
          }
        })
        .catch(error => {
          console.error('Error When Retriving Quiz Details ', error);
          reject(error, null);
        });
    });
  }

  handleUpdateAssignmentStatus = (assignment) => {
    const payload = {
      quiz_id: assignment.quiz_id,
      status: assignment.status === 0 ? 1 : 0
    };
    console.debug("payload>>>>>", payload)

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateAssignmentStatus',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
        if (res.data.data != null) {
          let tempQuizList = this.state.quiz_data;
          let index = tempQuizList.findIndex(quiz => quiz.quiz_id === assignment.quiz_id);
          if (index >= 0) {
            tempQuizList[index].status = payload.status;
            if (payload.status) {
              NotificationManager.success("Successfully Published", "", 2000);
            } else {
              NotificationManager.success("Successfully Unpublished", "", 2000);
            }
            console.debug(" tempQuizList[index]",  tempQuizList[index])
            this.setState({
              quiz_data: tempQuizList,
              slicedData: tempQuizList.slice(this.state.currentPageCount, this.state.currentPageCount+this.props.defaultRowsPerPage)
            });
          }
          
        }
      }
    })

  }

  handlePagination = (start, rowsPerPage) => {
    console.debug("start, rowsPerPage>>>", start, rowsPerPage)
    this.setState({
      slicedData: this.state.quiz_data.slice(start, start + rowsPerPage),
      currentPageCount: start,
    });
  };

  componentWillMount() {
    if (this.props.testMode) {
      //Load Dummy Data
      this.setState({
        loading: false,
        course_id: 8,
        course_name: 'course test 102',
        section_id: 16,
        section_name: 'add section 101',
        quiz_data: quizDataDummy,
        slicedData: quizDataDummy.slice(0, 4)
      });
    }if(this.props.archiveMode){
      this.setState({
        quiz_data: this.props.data,
        slicedData: this.props.data.slice(0, this.props.defaultRowsPerPage)
      });
      this.setState({ loading: false });
    }else {
      this.getQuizData(this.props.course_id, this.props.section_id).then(
        quizData => {
          this.setState({
            quiz_data: quizData,
            slicedData: quizData.slice(0, this.props.defaultRowsPerPage)
          });
          this.setState({ loading: false });
        }
      );
    }
    this.getNumberOfStudentsCompletedData(this.props.course_id, this.props.section_id).then(data=>{
      this.setState({
        loadingNumberOfCompletedStudent : false,
        NumberOfCompletedStudent : {...data}
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.course_id !== this.props.course_id ||
      nextProps.section_id !== this.props.section_id ) &&
      !this.props.archiveMode
    ) {
      this.setState({ loading: true });
      this.getQuizData(this.props.course_id, this.props.section_id).then(
        quizData => {
          this.setState({
            quiz_data: quizData,
            slicedData: quizData.slice(0, 4)
          });
          this.setState({ loading: false });
        }
      );
    }
    if(this.props.archiveMode && nextProps.data){
      this.setState({
        quiz_data: nextProps.data,
        slicedData: nextProps.data.slice(0, 10)
      });
    }
    if (
      (nextProps.course_id !== this.props.course_id ||
      nextProps.section_id !== this.props.section_id ) 
    ) {
      this.setState({ loadingNumberOfCompletedStudent: true });
      this.getNumberOfStudentsCompletedData(nextProps.course_id, nextProps.section_id).then(data=>{
        this.setState({
          loadingNumberOfCompletedStudent : false,
          NumberOfCompletedStudent : {...data}
        })
      })
    }
  }
  onQuizEditClick = event => {
    //console.debug("onQuizEditClick",event._targetInst._currentElement.props.id);
    let quizObject = JSON.parse(event.target.id); //event._targetInst._currentElement.props.id;
    this.props.onQuizEditClick(quizObject);
  };

  onScoreButtonClick = rowData => {
    this.props.onClick(rowData);
  };

  render() {
    if (this.state.loading) return <LoadingSpinner loading={true} />;

    const { slicedData, quiz_data } = this.state;
    const rows = quiz_data.length;

    return (
      <Grid gutter={2} spacing={1}>
        <Cell size={12}>
          <Grid
            gutter={3}
            className=" noMarigin styleScoreDistribution noHorizondalPadding noTopPadding"
          >
            <Cell size={12} phoneSize={12} className="noLineHeight">
              <p style={{fontSize:"medium"}}>
              Assignment List{' '}
                <div className="quizCount">{this.state.quiz_data.length}</div>
              </p>
    <span className="quizSubText">{this.appProperties.schoolMode?"Current Academic Year":"Current Semester"}</span>
            </Cell>
            <Cell size={12} className="noMarigin fullWidth">
              <Divider className="fullWidth" />
            </Cell>
            <Cell size={12} phoneSize={12} className="noMarigin fullWidth">
              <DataTable plain baseId="QuizTablePagination">
                <TableHeader>
                  <TableRow selectable={false}>
                  <TableColumn className="quizTableHeaderColumn">
                  Assignment ID
                  </TableColumn>
                  <TableColumn className="quizTableHeaderColumn">
                  Assignment Name
                  </TableColumn>
                    {/* <TableColumn className="quizTableHeaderColumn"></TableColumn> */}

                    <TableColumn className="quizTableHeaderColumn">
                      Due Date
                    </TableColumn>
                    <TableColumn style={{textAlign : "center"}} className="quizTableHeaderColumn">
                      # Completed
                      <Button className='nocqcStyle' icon tooltipLabel="Computed every night at 3.30am.">help</Button>
                    </TableColumn>
                    {/* <TableColumn className="quizTableHeaderColumn"></TableColumn> */}
                    {this.props.is_lti_enabled || this.props.archiveMode ? null :
                      <TableColumn className="quizTableHeaderActionColumn">
                        Publish/Unpublish
                      </TableColumn>
                    }
                    <TableColumn className="quizTableHeaderActionColumn">
                      Actions
                    </TableColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {slicedData.map((rowData, index) => (
                    <TableRow selectable={false} key={index}>
                    <TableColumn className="quizTableColumn">
                      {rowData.quiz_id}
                    </TableColumn>
                    <TableColumn className="quizTableColumn">
                    {rowData.quiz_name}
                    </TableColumn>
                      {/* <TableColumn className="quizTableColumn">{this.state.course_name}</TableColumn> */}

                      <TableColumn className="quizTableColumn">
                      {Moment(rowData.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")}
                      </TableColumn>
                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                      {this.state.loadingNumberOfCompletedStudent ? <LoadingSpinner loading={true} /> : (this.state.NumberOfCompletedStudent[rowData.quiz_id] || 0)}
                      </TableColumn>
                      {this.props.is_lti_enabled || this.props.archiveMode ? null :
                        <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                        <span style={{margin:'10px 2px'}}>
                              <SelectionControl
                                id={"switch-status" + index}
                                className={rowData.status == 1 ? 'course-status-toggle-on' : 'course-status-toggle-off'}
                                type="switch"
                                name="Status"
                                label={null}
                                checked={rowData.status === 1}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.handleUpdateAssignmentStatus(rowData)
                                }}
                                style={{ float: 'none', display: 'inline-block' }}
                                data-tip
                                data-for={rowData.status === 1 ? 'course-status-off' : 'course-status-on'}
                              />
                              <ReactTooltip id={'course-status-off'} type='light' className='tool-tip'>
                                <span>Click to Unpublish</span>
                              </ReactTooltip>
                              <ReactTooltip id={'course-status-on'} type='light' className='tool-tip'>
                                <span>Click to Publish</span>
                              </ReactTooltip>
                          </span>
                        </TableColumn>
                      }
                      {/* <TableColumn className="quizTableColumn"></TableColumn> */}
                      <TableColumn className="quizTableHeaderActionColumn">
                        {this.props.archiveMode?
                        null:
                        <Button
                          id={JSON.stringify(rowData)}
                          onClick={this.onQuizEditClick}
                          className="buttonBorder buttonNotification"
                          flat
                        >
                          Edit
                        </Button>
                        }
                        &nbsp;
                        <Button
                          id={rowData.quiz_name}
                          className="buttonBorder buttonNotification"
                          flat
                          onClick={() => this.onScoreButtonClick(rowData)}
                        >
                         {this.appProperties.eqmMode?"View Result":"View Raw Data"} 
                        </Button>
                        &nbsp;
                       
                      </TableColumn>
                    </TableRow>
                  ))}
                </TableBody>
                <TablePagination
                  rowsPerPageItems={[3, 8, 12, 16, 20]}
                  defaultRowsPerPage={this.props.defaultRowsPerPage?this.props.defaultRowsPerPage:3}
                  rows={rows}
                  rowsPerPageLabel=""
                  onPagination={this.handlePagination}
                />
              </DataTable>
            </Cell>
          </Grid>
        </Cell>
      </Grid>
    );
  }
}
